import { UnlinkedBottomContent } from './BottomContent/UnlinkedBottomContent';

export const Vigbo = {
    UnlinkedBottomContent,
};
